var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"py-3"},[(_vm.props.item[_vm.props.value])?_c('div',{staticClass:"rounded-full h-5 w-5 flex items-center justify-center text-white bg-green-500"},[_c('FontAwesomeIcon',{attrs:{"icon":['far', 'check']}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }